export const jyreSubscriptionUids = {
  PRO_TEAMS_PLAN: "pro-teams-plan",
  ASSESS: "jyre-assess",
  FREE_PLAN: "free-plan",
} as const;

export type JyreSubscriptionUids = (typeof jyreSubscriptionUids)[keyof typeof jyreSubscriptionUids];
